import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

export const isSuggestedUnsubscribeEnabled = () => {
    return (
        isMiniFeatureEnabled('mini-suggested-unsubscribe') &&
        isMiniHostAppFeatureEnabled('suggestedUnsubscribe')
    );
};
